<template>
  <loader :loading="!!user" height="200px">
    <b-card v-if="user && subscriptionQuota.marketplace">
      <b-card-body class="p-1">
        <div class="d-flex justify-content-between  mb-4">
          <div class="d-flex">
            <h4 class="card-title">{{ $t('components.dashboard_profile.title') }} </h4>
            ({{ $t('common.pricing.' + user.subscription.plan) }} {{ $t('common.plan') }})
          </div>
          <b-btn
              toggle-class="btn-sm"
              variant="success"
              right
              @click="upgrade"
              size="sm"
          >
            <i class="mdi mdi-arrow-up-circle-outline align-middle me-1"></i>
            {{ $t('components.dashboard_profile.upgrade') }}
          </b-btn>
        </div>
        <div>
          <div>
            <div>
              <b-row>
                <b-col :sm="feature === 'marketplace' ? '12' : '6'"  v-for="feature in features" :key="feature" class="mb-2">
                  <b-form-group class="mb-2">
                    <template $#label>
                      <label class="d-flex justify-content-between">
                      {{ $t(`components.dashboard_profile.${feature}`) }}
                      </label>
                    </template>
                    <b-progress height="0.8rem" class="mt-2" :max="subscriptionQuota[feature].used + subscriptionQuota[feature].remaining" striped show-value>
                      <b-progress-bar :value="subscriptionQuota[feature].used" variant="primary"></b-progress-bar>
                      <b-progress-bar :value="subscriptionQuota[feature].remaining" variant="light"></b-progress-bar>
                    </b-progress>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </loader>
</template>

<script>
import {quotaComputed, quotaMethods} from "@/state/helpers";

export default {
  name: "ProfileCard",
  props: ['user'],
  data() {
    return {
      features: [
        'marketplace',
        'product_track',
        'campaigns',
        'custom_template',
        'keyword_research',
        'product_research',
        'bg_remover',
      ]
    }
  },
  computed: {
    ...quotaComputed
  },
  methods: {
    ...quotaMethods,
    getUserQuota() {
      if (!this.subscriptionQuota?.marketplace) {
        this.getSubscriptionQuota()
      }
    },
    upgrade() {
      this.$router.push({name: 'settings', query: {tab: 'subscription', tm: +new Date()}})
    }
  },
  created() {
    this.getUserQuota()
  }
}
</script>

<style scoped>
td {
  padding: 6px 12px 6px 12px;
}

.badge {
  width: 48px !important;
  place-self: center;
}
/deep/.progress-bar.bg-light.progress-bar-striped {
  color: #495057;
}
</style>